<template>
    <div id="ksk-bindings" class="pt-3 page-container px-0">
        <h4 style="color: #363e59" class="hidden-sm-and-up mb-3">{{ $t('КСК Дома') }}</h4>

        <v-row class="page-container mb-3 px-0" no-gutters>
            <v-col cols="12" sm="4" class="px-0">
                <KSKBindingModal isNew @KSKBindingsUpdated="updateTable" />
            </v-col>

            <v-col cols="12" sm="6"></v-col>

            <v-col cols="12" sm="2" class="px-0 d-flex justify-end">
                <KSKBindingsFilter @filter="updateFilter" />
            </v-col>
        </v-row>

        <v-data-table
            :loading="tableItemsLoading"
            id="dataTableUsers"
            :class="{ 'elevation-2': !$vuetify.breakpoint.xsOnly }"
            :headers="headers"
            :items="itemsTranslated"
            :options.sync="tableOptions"
            :server-items-length="serverItemsLength"
            :footer-props="{ 'items-per-page-options': $vuetify.breakpoint.xsOnly ? [1] : [10, 15, 20, 25] }"
            ref="table"
        >
            <template #[`item.actions`]="{ item }">
                <div class="d-flex">
                    <KSKBindingModal :details="item" @KSKBindingsUpdated="updateTable" />
                    <DeleteBindingDialog :details="item" @deletionConfirmed="deleteBinding(item)" />
                </div>
            </template>
        </v-data-table>
        <table-arrows :table="$refs.table"></table-arrows>
    </div>
</template>

<script>
import translate from '@/utils/translate.util';
// import TableCellTooltip from '@/components/ui/TableCellTooltip';
import TableArrows from '@/components/ui/TableArrows';
// import UpdateActiveUserDialog from '@/components/administration/UpdateActiveUserDialog.vue';
import KSKBindingModal from '@/components/administration/KSKBindingModal.vue';
import DeleteBindingDialog from '@/components/administration/DeleteBindingDialog.vue';
import KSKBindingsFilter from '@/components/administration/KSKBindingsFilter.vue';

import { isEqual } from 'lodash';

import KSKService from '@/services/apiRequests/ksk.service';

export default {
    components: {
        // UpdateActiveUserDialog,
        KSKBindingModal,
        DeleteBindingDialog,
        KSKBindingsFilter,
        // TableCellTooltip,
        TableArrows
    },
    data() {
        return {
            tableOptions: {
                groupBy: [],
                groupDesc: [],
                itemsPerPage: 10,
                multiSort: false,
                mustSort: false,
                page: 1,
                sortBy: [],
                sortDesc: []
            },
            filters: [],
            tableItemsLoading: false,
            tempItems: [],
            serverItemsLength: 0
        };
    },
    computed: {
        itemsTranslated() {
            return translate(this.tempItems, 'full', this.$i18n.locale);
        },

        headers() {
            return [
                {
                    text: this.$t('administration.kskName'),
                    value: 'isas_ksk_name'
                },
                {
                    text: this.$t('administration.houseAddress'),
                    value: 'isas_address_full_name'
                },
                {
                    text: this.$t('administration.startDate'),
                    value: 'date_begin',
                    width: 150
                },
                {
                    text: this.$t('administration.endDate'),
                    value: 'date_end',
                    width: 150
                },
                {
                    text: '',
                    value: 'actions',
                    sortable: false,
                    width: 120
                }
            ];
        }
    },
    watch: {
        tableOptions: {
            handler: async function(newOptions, oldOptions) {
                if (isEqual(newOptions, oldOptions)) return;

                this.fetchBindings();
            },
            deep: true
        }
    },
    mounted() {
        this.fetchBindings();
    },
    methods: {
        updateTable() {
            this.tableOptions.page = 1;
            this.fetchBindings();
        },

        updateFilter(filters = []) {
            this.filters = filters;
            this.fetchBindings();
        },
        async fetchBindings() {
            try {
                this.tableItemsLoading = true;

                const ascDesc = this.tableOptions.sortDesc[0] ? 'desc' : 'asc';
                const orderBy = this.tableOptions.sortBy.length ? `${this.tableOptions.sortBy[0]},${ascDesc}` : null;

                const response = await KSKService.getKSKtoHouseBindings(this.tableOptions.itemsPerPage, this.tableOptions.page, orderBy, [...this.filters]);

                this.tempItems = response.isas_ksk_houses_period || [];
                this.serverItemsLength = response.pagination.row_count || 0;
            } finally {
                this.tableItemsLoading = false;
            }
        },

        async deleteBinding(item) {
            await KSKService.deleteKSKtoHouseBinding(item.isas_period_rid);

            this.$store.dispatch('base/showMessage', {
                message: this.$t('Привязка удалена')
            });
            this.updateTable();
        }
    }
};
</script>

<style lang="scss">
// #ksk-bindings {
//     table {
//         table-layout: fixed;
//     }
// }
</style>
